import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "./childComponents/basicDetail.css";

const CustomDatePicker = ({
  value,
  onChange,
  maximumDate,
  minimumDate,
  mode,
  ...props
}) => {
  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      maxDate={maximumDate}
      minDate={minimumDate}
      dateFormat="dd-MM-yyyy"
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      yearDropdownItemNumber={70}
      scrollableYearDropdown
      {...props}
    />
  );
};

export const BasicDetailImport = {
  DatePicker: CustomDatePicker,
};
